<div class="message-tag"
    [ngClass]="{'message-gray': color === 'gray', 'message-faint': color === 'faint', 'message-purple': color === 'purple', 'lavender': color === 'lavender', 'no-remove': noRemove}">
  <h6>{{tag}}</h6>
  <span class="remove-tag" (click)="onRemove()" *ngIf="!noRemove"></span>
</div>